import { Tooltip } from "@/components/ui/tooltip";
import { TruckListEntity } from "@/pages/config/trucks/schema/trucks.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: TruckListEntity;
  handleDetail: (id: any) => void;
}

export const TrucksActions = ({ handleDetail, item }: Props) => {
  //Acciones para orden de venta
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item?.id)}
          data-testid="trucks-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
